'use strict';

wbApp.controller('TaxDocumentsCtrl', ['$scope', '$q', '$window', '$translate', '$filter', 'semesterSvc',
    'taxDocumentsSvc', 'accountingBookSvc', 'securitySvc', 'gridSortSvc', 'messageBoxSvc', 'notificationSvc',
function ($scope, $q, $window, $translate, $filter, semesterSvc,
    taxDocumentsSvc, accountingBookSvc, securitySvc, gridSortSvc, messageBoxSvc, notificationSvc) {

    $scope.customFilter = { accountingBooks: [] };
    $scope.rawTaxDocuments = [];
    $scope.taxDocuments = [];
    $scope.filteredRows = [];

    $scope.accountingBooks = accountingBookSvc.getAllAsync();

    function preFilter() {
        $q.all([$scope.rawTaxDocuments.$promise, $scope.accountingBooks.$promise]).then(function () {
            var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
            $scope.taxDocuments.length = 0;
            $scope.taxDocuments.push.apply($scope.taxDocuments,
                _.filter($scope.rawTaxDocuments, function (o) {
                    
                    if (accountingBookIDs.length > 0) {
                        return _.includes(accountingBookIDs, o.accountingBookID);
                    }

                    return true;
                })
            );
        });
    }

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    $scope.gridSettings = {
        name: 'taxDocuments',
        columns: [
            { dataField: 'taxDocumentNo', caption: $translate.instant('TXT_LBL_TAX_DOCUMENT_NO'), dataType: 'number', width: '100px', sortOrder: 'dsc' },
            { dataField: 'invoiceNo', caption: $translate.instant('TXT_LBL_INVOICE_NO'), dataType: 'number', width: '100px' },
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'operatorFullName', caption: $translate.instant("TXT_LBL_PARENT"), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'operatorFullName') }
            },
            { dataField: 'subject', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string' },
            { dataField: 'issueDate', caption: $translate.instant('TXT_LBL_INVOICE_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'total', caption: $translate.instant('TXT_LBL_AMOUNT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'accountingBookID', caption: $translate.instant('TXT_LBL_ACCOUNTING_BOOK'), dataType: 'number', visible: false },
        ],
        //onRowPrepared: function (e) {
        //    if (e.rowType == "data") {
        //        var data = e.component.getKeyByRowIndex(e.rowIndex);
        //        if (data.notLatest) {
        //            e.rowElement.addClass('text-muted');
        //        }
        //    }
        //},       
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_TAX_DOCUMENT'),
            isVisible: function (row) {
                return securitySvc.isInRole('TaxDocument.Print') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintTaxDocument(row.taxDocumentID, 'pdf'); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_TAX_DOCUMENT_ALL'),
            isVisible: function (row) {
                return securitySvc.isInRole('TaxDocument.Print') && securitySvc.isInRole('Reports');
            },
            callback: function (row, allRows) { onPrintTaxDocumentAll(row, allRows); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintInvoice(row.invoiceID); }
        }, {
            text: $translate.instant('TXT_MENU_STORMWARE_EXPORT'),
            callback: function (row, allRows) { onStormwareExportRequested(row, allRows); }
        }, {
            text: $translate.instant('TXT_MENU_MONEYS3_EXPORT'),
            callback: function (row, allRows) { onMoneyS3ExportRequested(row, allRows); }
        }, {
            text: $translate.instant('TXT_MENU_CSV_EXPORT'),
            callback: function (row, allRows) { onCsvExportRequested(row, allRows); }
        }, {
            text: $translate.instant('TXT_EXPORT_TAX_DOCUMENT_TO_EXCEL'),
            isVisible: function (row) {
                return securitySvc.isInRole('TaxDocument.Print') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintTaxDocument(row.taxDocumentID, 'xls'); }
        }]
    }

    function onPrintTaxDocumentAll(row) {
        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICES_PRINT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_PRINT').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        var taxDocumentsIDs = encodeURIComponent(JSON.stringify(_.map($scope.filteredRows, 'taxDocumentID')));

        $window.open('/Admin/Report/TaxDocumentAll?taxDocumentsIDs=' + taxDocumentsIDs,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }


    $scope.onFilterApplied = function (filteredRows) {
        $scope.filteredRows = filteredRows;
    }

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onPrintTaxDocument(taxDocumentID, format) {

        if (format == 'xls') {
            $("#dataDownloadIFrame").remove();
            $("body").append("<iframe id='dataDownloadIFrame' src='/Admin/Report/TaxDocument?TaxDocumentID=" + taxDocumentID + "&format=" + format + "' style='height: 0px;' ></iframe>");

        }
        else {
            $window.open('/Admin/Report/TaxDocument?TaxDocumentID=' + taxDocumentID,
                '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        }
    }

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            $scope.rawTaxDocuments = taxDocumentsSvc.GetBriefBySemester($scope.semesterID);
            $scope.selectedTaxDocument = null;
            preFilter();
        }
    });

    $q.all([semesterSvc.getDefaultAsync()])
    .then(function (data) {
        if (data[0]) {
            $scope.semesterID = data[0].id;
        }

        // get taxDocuemnts
        $scope.rawTaxDocuments = taxDocumentsSvc.GetBriefBySemester($scope.semesterID);
        preFilter();    
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            // get taxDocuemnts
            $scope.rawTaxDocuments = taxDocumentsSvc.GetBriefBySemester(semesterID);
            $scope.selectedTaxDocument = null;
            preFilter();
        }
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedTaxDocument = data;
    }

    function onStormwareExportRequested(row) {

        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT_TD').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            taxDocumentsSvc.getStormwareTaxDocumentExport(row.accountingBookID, _.map($scope.filteredRows, 'taxDocumentID'),
                onStormwareExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_SERVER_ERROR'),
                    notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_TAX_DOCUMENT_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }


    function onMoneyS3ExportRequested(row)
    {
        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT_TD').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            taxDocumentsSvc.getMoneyS3TaxDocumentExport(row.accountingBookID, _.map($scope.filteredRows, 'taxDocumentID'),
                onStormwareExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_SERVER_ERROR'),
                    notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_TAX_DOCUMENT_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }

    function onCsvExportRequested(row)
    {
        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT_TD').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            taxDocumentsSvc.getCsvTaxDocumentExport(row.accountingBookID, _.map($scope.filteredRows, 'taxDocumentID'),
                onStormwareExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_SERVER_ERROR'),
                        notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_TAX_DOCUMENT_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }

    function onStormwareExportGenerated(data) {
        $("#dataDownloadIFrame").remove();
        $("body").append("<iframe id='dataDownloadIFrame' src='/Api/TaxDocuments/Download?fileName=" + data.fileName + "' style='height: 0px;' ></iframe>");
    }

}]);
